<div
  class="app-shell-wrapper"
  [ngStyle]="{ 'flex-direction': isMobileScreen ? 'column' : 'row' }"
  data-cy="app-shell-wrapper"
>
  <!-- Mobile Navigation Bar -->
  <div *ngIf="isMobileScreen" class="mobile-dropdown">
    <div class="mobile-header">
      <img [src]="getPrimaryLogoSrc()" alt="image" class="logo-image" />
      <fa-icon [icon]="icons['faBars']" class="header-icon" (click)="onToggleMobileDropdown()" data-cy="nav-toggle" />
    </div>

    <div class="dropdown-content" *ngIf="showMobileDropdown">
      <a class="nav-link" (click)="closeMobileDropdown(); onNavigation('dashboard')" routerLinkActive="active">
        <div class="nav-link-content">
          <fa-icon [icon]="icons['faHouse']" class="mr-3"></fa-icon>
          <span class="nav-label">Dashboard</span>
        </div>
      </a>
      <a
        *ngIf="shouldShowMenuItem(AccessType.MerchantAdmin)"
        class="nav-link"
        (click)="closeMobileDropdown(); onNavigation('merchants')"
        routerLinkActive="active"
        data-cy="nav-merchants"
      >
        <div class="nav-link-content">
          <fa-icon [icon]="icons['faStore']" class="mr-3"></fa-icon>
          <span class="nav-label">Merchants</span>
        </div>
      </a>
      <a
        *ngIf="shouldShowMenuItem(AccessType.Billing)"
        class="nav-link"
        (click)="closeMobileDropdown(); onNavigation('billing-cycles')"
        routerLinkActive="active"
      >
        <div class="nav-link-content">
          <fa-icon [icon]="icons['faEnvelope']" class="mr-3"></fa-icon>
          <span class="nav-label">Billing</span>
        </div>
      </a>
      <a class="nav-link" (click)="onToggleAdminSubmenu()">
        <div class="nav-link-content">
          <fa-icon [icon]="icons['faGear']" class="mr-3"></fa-icon>
          <span class="nav-label">Admin</span>
        </div>
        <i class="bi" [ngClass]="showAdminSubmenu ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
      </a>
      <ng-container *ngIf="showAdminSubmenu">
        <a
          *ngIf="shouldShowMenuItem(AccessType.RepresentativeAdmin)"
          class="nav-link nav-link-child"
          (click)="closeMobileDropdown(); onNavigation('admin/representatives')"
          routerLinkActive="active"
        >
          <div class="nav-link-content">
            <fa-icon [icon]="icons['faUsersCog']" class="mr-3"></fa-icon>
            <span class="nav-label">Representatives</span>
          </div>
        </a>
      </ng-container>
    </div>
  </div>

  <!-- Tablet/Desktop Navigation Bar -->
  <div
    *ngIf="!isMobileScreen"
    [ngClass]="{
      'minimized-sidebar': (isSmallScreen && !shouldShowFullWidth) || !shouldShowFullWidth
    }"
  >
    <div class="side-navigation-bar">
      <div class="side-navigation-bar-header">
        <img [src]="getImageSrc()" alt="image" class="logo-image" />
      </div>
      <!-- Your side navigation bar content here -->
      <nav class="nav">
        <a
          class="nav-link"
          (click)="onNavigation('dashboard')"
          routerLinkActive="active"
          [pTooltip]="isSmallScreen ? 'Dashboard' : ''"
        >
          <div class="nav-link-content">
            <fa-icon [icon]="icons['faHouse']" class="mr-3"></fa-icon>
            <span class="nav-label">Dashboard</span>
          </div>
        </a>
        <a
          *ngIf="shouldShowMenuItem(AccessType.MerchantAdmin)"
          class="nav-link"
          (click)="onNavigation('merchants')"
          routerLinkActive="active"
          [pTooltip]="isSmallScreen ? 'Merchants' : ''"
          data-cy="nav-merchants-mobile"
        >
          <div class="nav-link-content">
            <fa-icon [icon]="icons['faStore']" class="mr-3"></fa-icon>
            <span class="nav-label">Merchants</span>
          </div>
        </a>
        <a
          *ngIf="shouldShowMenuItem(AccessType.Billing)"
          class="nav-link"
          (click)="onNavigation('billing-cycles')"
          routerLinkActive="active"
          [pTooltip]="isSmallScreen ? 'Billing' : ''"
        >
          <div class="nav-link-content">
            <fa-icon [icon]="icons['faEnvelope']" class="mr-3"></fa-icon>
            <span class="nav-label">Billing</span>
          </div>
        </a>
        <a class="nav-link" (click)="onToggleAdminSubmenu()" [pTooltip]="isSmallScreen ? 'Admin' : ''">
          <div class="nav-link-content">
            <fa-icon [icon]="icons['faGear']" class="mr-3"></fa-icon>
            <span class="nav-label">Admin</span>
          </div>
          <i class="bi" [ngClass]="showAdminSubmenu ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
        </a>
        <ng-container *ngIf="showAdminSubmenu">
          <a
            *ngIf="shouldShowMenuItem(AccessType.RepresentativeAdmin)"
            class="nav-link nav-link-child"
            (click)="onNavigation('admin/representatives')"
            routerLinkActive="active"
            [pTooltip]="isSmallScreen ? 'Representatives' : ''"
          >
            <div class="nav-link-content">
              <fa-icon [icon]="icons['faUsersCog']" class="mr-3"></fa-icon>
              <span class="nav-label">Representatives</span>
            </div>
          </a>
        </ng-container>
        <a
          (click)="onNavigationTheme()"
          class="nav-link"
          routerLinkActive="active"
          [pTooltip]="isSmallScreen ? 'Theme' : ''"
        >
          <div class="nav-link-content">
            <i class="bi bi-palette-fill"></i>
            <span class="nav-label ml-2">Theme</span>
          </div>
        </a>
      </nav>
    </div>
  </div>

  <!-- Main Content -->
  <div class="main-content">
    <app-header (closeClicked)="onCloseClicked()"></app-header>
    <div class="app-content">
      <!-- Your main content, including header and router-outlet -->
      <p-breadcrumb *ngIf="(shouldShowBreadcrumbs$ | async) === true" [model]="(breadcrumbs$ | async) || []">
        <ng-template pTemplate="item" let-item>
          <ng-container>
            <div (click)="item.command()" class="breadcrumb-item">
              <fa-icon *ngIf="item.icon" [icon]="icons[item.icon]" size="xl"></fa-icon>
              <span>{{ item.label }}</span>
            </div>
          </ng-container>
        </ng-template>
      </p-breadcrumb>
      <div id="coalition-portal-routing-wrapper">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
